<div
  *ngIf="!this.isLoading"
  class="container p-4 mx-auto bg-white rounded-lg shadow-lg sm:p-6 lg:p-8">
  <div class="w-full p-2 m-2">
    <!-- Header Section -->
    <div class="flex items-center justify-between">
      <div class="mb-7">
        <h1 class="mb-1 text-2xl font-semibold text-primary-200">
          View Subscription
        </h1>
      </div>
    </div>
    <div class="flex items-center justify-between">
      <p-breadcrumb
        class="max-w-full"
        [model]="breadCrumbItems"
        [home]="home" />
    </div>
  </div>
  <p-card class="p-card">
    <div class="text-right">
      <p-button (click)="menu.toggle($event)" icon="pi pi-ellipsis-v" />
    </div>
    <p-menu appendTo="body" #menu [model]="items" [popup]="true" />
      <div class="w-full p-7">
        <ng-template pTemplate="header">
          <h2 class="text-2xl font-bold">Subscription Details</h2>
        </ng-template>
        <div class="col-span-12 mb-4 md:col-span-6">
          <label for="status" class="block mb-1 font-bold">Plan</label>
          <label>
            {{ object?.plan!.name }}
          </label>
        </div>
        <div class="col-span-12 mb-4 md:col-span-6">
          <label for="status" class="block mb-1 font-bold">Status</label>

          <label>
            {{ object?.status }}
          </label>
        </div>
        <div class="col-span-12 mb-4 md:col-span-6">
          <label for="status" class="block mb-1 font-bold">Next Due</label>
          {{ object?.next_due | date : "medium" }}
        </div>

        <div class="col-span-12 mb-4 md:col-span-6">
          <label for="status" class="block mb-1 font-bold">Months to Bill</label>
          {{ object?.months_to_bill }}
        </div>

        <div class="col-span-12 mb-4 md:col-span-6">
          <label for="status" class="block mb-1 font-bold">Amount</label>
          {{ object?.amount | currency : "USD" }}
        </div>
        <div class="col-span-12 mb-4 md:col-span-6">
          <label for="status" class="block mb-1 font-bold">
            Actual Amount
          </label>

          {{ object?.actual_amount | currency : "USD" }}
        </div>
        <ng-template pTemplate="footer">
          <button
            pButton
            label="Back to List"
            icon="pi pi-arrow-left"
            class="p-button-secondary"
            routerLink="/conduit/list"></button>
        </ng-template>
      </div>
    </p-card>
  </div>
